<template>
  <v-row>
    <div style="display: flex; flex-direction: row; flex-grow: 1; align-items: stretch; flex-wrap: wrap">
      <!-- Server Information -->
      <v-col cols="12" sm="6">
        <gg-card style="height: 100%">
          <gg-card-text class="pa-3">
            <div class="body-1 mb-5">
              <v-icon size="24" color="primary" class="pb-1 pl-2">mdi-account-card-details</v-icon>
              <span class="ml-2 font-weight-medium">Server Information</span>
            </div>
            <v-row class="pb-3 pl-2 pr-2">
              <v-col cols="2" class="pb-0 font-bold">Username:</v-col>
              <v-col cols="10" class="pb-0 text-right">
                {{ accountData.user }}
                <gg-btn icon class="ml-1" @click="copyToClipboard(accountData.user)">
                  <v-icon small>mdi-content-copy</v-icon>
                </gg-btn>
              </v-col>

              <v-col cols="2" class="pb-0 pt-0 font-bold">Hostname:</v-col>
              <v-col cols="10" class="pb-0 pt-0 text-right">
                {{ accountData.server_hostname }}
                <gg-btn icon class="ml-1" @click="copyToClipboard(accountData.server_hostname)">
                  <v-icon small>mdi-content-copy</v-icon>
                </gg-btn>
              </v-col>

              <v-col cols="2" class="pb-0 pt-0 font-bold">IP:</v-col>
              <v-col cols="10" class="pb-0 pt-0 text-right">
                {{ accountData.ip }}
                <gg-btn icon class="ml-1" @click="copyToClipboard(accountData.ip)">
                  <v-icon small>mdi-content-copy</v-icon>
                </gg-btn>
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
      </v-col>

      <!-- Domain Nameservers -->
      <v-col cols="12" sm="6">
        <gg-card style="height: 100%">
          <gg-card-text class="pa-3">
            <div class="body-1 mb-5">
              <v-icon size="24" color="primary" class="pb-1 pl-2">mdi-mixcloud</v-icon>
              <span class="ml-2 font-weight-medium">Domain Nameservers</span>
            </div>
            <v-row class="pb-3 pl-2 pr-2">
              <v-col cols="12" class="pb-0">ns1.greengeeks.net</v-col>

              <v-col cols="12" class="pb-0 pt-1">ns2.greengeeks.net</v-col>

              <v-col v-if="isResellerService" cols="12" class="pb-0">
                <gg-btn
                  secondary
                  class="mr-1"
                  @click="goToKnowledgebase()"
                >
                  Use Custom Nameservers
                  <v-icon small class="pl-2">mdi-open-in-new</v-icon>
                </gg-btn>
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
      </v-col>
      <!-- Password Management -->
      <v-col v-if="isResellerSubAccount && !isResellerMainAccount" cols="12" sm="6">
        <gg-card>
          <gg-card-text class="pa-3">
            <div class="body-1 mb-5">
              <v-icon size="24" color="primary" class="pb-1">mdi-lock</v-icon>
              <span class="ml-2">Password Management</span>
            </div>
            <div>
<!--              <router-link :to="`/hosting/shared/${hosting.id}/password?user=${this.$route.query.user}`" class="ma-0 font-bold">-->
              <router-link :to="changePasswordRoute" class="ma-0 font-bold">
                Change Password
              </router-link>
            </div>
          </gg-card-text>
        </gg-card>
      </v-col>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isEmpty, statusColor, percent, humanFileSize } from '@/helpers/helpers'
import isResellerRoute from '@/mixins/isResellerRoute'
import { ExternalLinks } from '@/consts/main'
import { SERVICE_TYPES } from '@/consts/service'

export default {
  name: 'ServiceDomainServiceInfo',
  mixins: [isResellerRoute],
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters(['hosting_detail', 'hosting']),
    isResellerService () {
      return this.hosting.type === SERVICE_TYPES.RESELLER
    },
    isResellerSubAccount () {
      return this.isResellerService && this.$route.query.user
    },
    isResellerMainAccount () {
      return this.isResellerService && this.$route.query.user === this.hosting.username
    },
    accountData () {
      const data = {
        user: this.hosting_detail?.accountsummary?.user || '',
        server_hostname: this.hosting_detail?.accountsummary?.server_hostname || '',
        ip: this.hosting_detail?.accountsummary?.ip || '',
        diskused: this.hosting_detail?.accountsummary?.diskused || 0,
        disklimit: this.hosting_detail?.accountsummary?.disklimit || 0,
        inodesused: this.hosting_detail?.accountsummary?.inodesused || 0,
        inodeslimit: this.hosting_detail?.accountsummary?.inodeslimit || 0,
        bw_limit: this.hosting_detail?.showbw?.limit || 0,
        bw_used: this.hosting_detail?.showbw?.totalbytes || 0,
      }
      if (this.isResellerService && this.isResellerMainAccount) {
        data.user = this.hosting.username || ''
        data.server_hostname = this.hosting_detail?.hostname || ''
        data.ip = this.hosting_detail?.ip || ''
        data.diskused = this.hosting_detail?.diskused || 0
        data.disklimit = this.hosting_detail?.disklimit || 0
        data.inodesused = this.hosting_detail?.inodesused || 0
        data.inodeslimit = this.hosting_detail?.inodeslimit || 0
        data.bw_limit = this.hosting_detail?.bw_limit || 0
        data.bw_used = this.hosting_detail?.bw_used || 0
      }
      return data
    },
    changePasswordRoute () {
      if (this.hosting.groupname === 'Shared Hosting' || this.isResellerSubAccount) {
        return { name: 'hosting_cpanel_password', query: { user: this.$route.query.user } }
      } else if (this.hosting.groupname === 'Reseller Hosting') {
        return { name: 'hosting_whm_password' }
      } else if (this.hosting.groupname === 'Virtual Private Server') {
        return { name: 'hosting_vserver_password' }
      }
      return { name: 'hosting_cpanel_password' }
    }
  },
  methods: {
    ...mapActions(['reportSuccess']),
    statusColor,
    percent,
    humanFileSize,
    isEmpty,
    copyToClipboard (text) {
      navigator.clipboard.writeText(text)
      this.reportSuccess('Copied')
    },

    goToKnowledgebase () {
      window.open(ExternalLinks.GG_CUSTOM_NAMESERVERS_KB, '_blank')
    }
  },
}
</script>
